import { render, staticRenderFns } from "./ReligionCards.vue?vue&type=template&id=7ec92d7f&"
import script from "./ReligionCards.vue?vue&type=script&lang=js&"
export * from "./ReligionCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports